module.exports = __webpack_public_path__ + "img/gx_01.7e55b70e.png";